import * as Sentry from '@sentry/react';

import { PlatformBridge } from '@/bridge/bridge';

const isPrintMode =
  typeof window !== 'undefined' &&
  (new URLSearchParams(window.location.search).get('print') === '1' ||
    window.location.pathname.startsWith('/cv/preview') ||
    navigator.userAgent.includes('HeadlessChrome'));

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const isValidDsn = Boolean(
  dsn && dsn.trim() !== '' && !dsn.includes('[EMAIL]') && dsn.startsWith('http'),
);
const sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';
const enabled = isValidDsn && sentryEnabled && !isPrintMode;

Sentry.init({
  dsn: isValidDsn ? dsn : undefined,
  enabled,
  environment: import.meta.env.MODE,
  release: 'web@0.0.0',
  tracesSampleRate: 0.1,
  enableLogs: true,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  integrations: [Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })],
});

if (typeof window !== 'undefined' && enabled) {
  Sentry.setTag('platform', PlatformBridge.platform);
}
